// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2_K-J","head":"ProcedureTableInfo_head__QFlw3"};